import { defineComponent } from "vue";

export default defineComponent({
    props: {
        activeItem: {
            type: HTMLElement
        },
        outlineStyle: {
            type: String
        },
        isGradientUnderline: {
            type: Boolean,
            default: false
        },
        recalculateDimensions: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            sliderWidth: null,
            sliderLeft: null,
            sliderBottom: null,
            resizeObserver: null as ResizeObserver
        };
    },
    watch: {
        activeItem: {
            immediate: true,
            handler(el) {
                this.recalculate(el);
            }
        },
        recalculateDimensions: {
            handler() {
                this.recalculate(this.activeItem);
            }
        }
    },
    computed: {
        underlineStyle() {
            if (this.sliderWidth === null || this.sliderLeft === null || this.sliderBottom === null) return {};

            return {
                left: `${this.sliderLeft + this.sliderWidth / 2 - 400 / 2}px`,
                top: `${this.sliderBottom}px`,
                paddingLeft: `${(400 - this.sliderWidth) / 2}px`,
                paddingRight: `${(400 - this.sliderWidth) / 2}px`
            };
        }
    },
    methods: {
        updateSliderDimensions(el) {
            this.sliderWidth = el ? el.offsetWidth : null;
            this.sliderLeft = el ? el.offsetLeft : null;
            this.sliderBottom = el ? el.offsetTop + el.offsetHeight - 5 : null;
        },

        teardownObserver() {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
            }
        },
        recalculate(el) {
            this.teardownObserver();

            if (!el) return;

            this.$nextTick(() => {
                this.updateSliderDimensions(el);

                this.resizeObserver = new ResizeObserver(() => {
                    this.updateSliderDimensions(el);
                });

                this.resizeObserver.observe(el);
            });
        }
    }
});
